var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-column gap-2"},[_vm._t("title",function(){return [_c('title-node',_vm._b({},'title-node',_vm.computedTitle,false))]}),_c('div',{staticClass:"pl-4"},[(!!_vm.content)?_c('form-node',_vm._b({},'form-node',_vm.content,false)):_vm._t("default")],2)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }